import { PAY_FREQUENCIES } from '@/lib/constants/payFrequencies'

let getPayFrequencyLabel = (payFrequencyId) => {
  return PAY_FREQUENCIES[payFrequencyId]
}

export default getPayFrequencyLabel
